export function MiniBars({
  data,
  height = 96,
  formatValue = (v: number) => String(v),
}: {
  data: { label: string; value: number }[]
  height?: number
  formatValue?: (v: number) => string
}) {
  const max = Math.max(...data.map((d) => d.value), 1)
  return (
    <div className="bars" style={{ height }}>
      {data.map((d, i) => (
        <div className="bar" key={`${d.label}-${i}`} title={`${d.label} · ${formatValue(d.value)}`}>
          <div className="bar__fill" style={{ height: `${Math.max(4, (d.value / max) * 100)}%` }}>
            {i === data.length - 1 ? <span className="bar__tip">{formatValue(d.value)}</span> : null}
          </div>
        </div>
      ))}
    </div>
  )
}

export function MiniBarsLabels({ labels }: { labels: string[] }) {
  return (
    <div className="bars-labels">
      {labels.map((l, i) => (
        <span key={`${l}-${i}`}>{l}</span>
      ))}
    </div>
  )
}

export function HBar({ value, max, tone = 'primary' }: { value: number; max: number; tone?: 'primary' | 'muted' }) {
  return (
    <div className="hbar">
      <div
        className="hbar__fill"
        style={{
          width: `${Math.max(2, (value / Math.max(max, 1)) * 100)}%`,
          background:
            tone === 'primary'
              ? 'linear-gradient(90deg, hsl(var(--primary)), hsl(var(--primary-strong)))'
              : 'hsl(var(--muted-foreground) / .5)',
        }}
      />
    </div>
  )
}
